<customer-select class="mx:hidden sm:block sm:w-full"></customer-select>
<div class="order-history__container sm:px-4 mx:px-8">
    <div class="order-history__tabs">
        <nz-tabset [(nzSelectedIndex)]="tabSelectedIndex"  [nzTabBarExtraContent]="extraTemplate">
            <nz-tab [nzTitle]="'ORDER_HISTORY'| translate">
              <ng-template nz-tab>
              <order-history [tabSelectedIndex]="tabSelectedIndex"></order-history>
              </ng-template>
            </nz-tab>
            <nz-tab  [nzTitle]="'ITEM_HISTORY'| translate">
              <ng-template nz-tab>
                <item-history [tabSelectedIndex]="tabSelectedIndex"></item-history>
            </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="'DELIVERY_HISTORY'| translate">
                <ng-template nz-tab>
                    <delivery-history-component [tabSelectedIndex]="tabSelectedIndex"></delivery-history-component>
                </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="'FINANCIAL'| translate" *ngIf="hasPermission('financial')">
              <ng-template nz-tab>
                <app-financial-data [tabSelectedIndex]="tabSelectedIndex"></app-financial-data>
              </ng-template>
            </nz-tab>
            <!-- <nz-tab [nzTitle]="'INVOICE_DATA'| translate">
              <ng-template nz-tab>
                <invoice-data></invoice-data>
              </ng-template>
            </nz-tab> -->
        </nz-tabset>
        <ng-template #extraTemplate>
          <customer-select class="sm:hidden mx:block"></customer-select>
          </ng-template>
    </div>
</div>
